import { StringIterator } from 'lodash';
import { BaseModel } from '../../../../../../core/_base/crud';
export class TonKhoHienTai extends BaseModel {
        static optionsTinhTrang = [
                {
                        name: 'Không cho phép xuất',
                        value: false
                },
                {
                        name: 'Cho phép xuất',
                        value: true
                }
        ];

        static COPYTAG = { FALSE: false, TRUE: true }
        static COPYNOTEQA = { FALSE: false, TRUE: true }
        static CHECKALL = { FALSE: false, TRUE: true }
        static MODIFY_INVENTORY_TAGS = "060033";
        static MODIFY_INVENTORY_NOTE_QA = "1541";
        static INDEX_TAG = 0;
        static INDEX_NOTE_QA = 1;
        static POPUP_MULTIPLE = [
                {
                        Code: "TAG",
                        Title: "Chọn tag",
                        SubTitle: "Chọn tag tại đây ...",
                        AlertInfo: "Di chuyển đến cột Tag và chọn những dòng cần lưu!",
                        Popup: "Tag"
                },
                {
                        Code: "NOTE_QA",
                        Title: "Nhập ghi chú",
                        SubTitle: "Nhập ghi chú tại đây ...",
                        AlertInfo: "Di chuyển đến cột ghi chú QA và chọn những dòng cần lưu!",
                        Popup: "Ghi chú QA"
                }
        ]

        IdTk: number
        IdKho: number
        TenKho: string
        MaKho: string
        IdHh: number
        TenHH: string
        MaHH: string
        Solo: string
        Soluong: string
        Sopo: string
        Tinhtrang: boolean
        Ghichu: string
        Dvt: number
        TenDVT: string
        TenNHH: string
        TenLoaiHH: string
        HanSuDung: any
        NgaySanXuat: any
        TagInfo: string[]
        PalletText: string
        MaSub: string
        SoXeSoMe: string
        NgayNhanHang: string
        GhiChuDNNK: string
        MaNCC: string
        TenNCC: string
        clear() {
                this.IdTk = 0;
                this.IdKho = 0;
                this.TenKho = '';
                this.MaKho = '';
                this.IdHh = 0;
                this.TenHH = '';
                this.MaHH = '';
                this.Solo = '';
                this.Soluong = '';
                this.Sopo = '';
                this.Tinhtrang = true;
                this.Ghichu = '';
                this.Dvt = 0;
                this.TenDVT = '';
                this.TenNHH = '';
                this.TenLoaiHH = '';
                this.HanSuDung = '';
                this.NgaySanXuat = '';
                this.TagInfo = [];
                this.PalletText = '';
                this.MaSub = '';
                this.SoXeSoMe = '';
                this.NgayNhanHang = ''
                this.GhiChuDNNK = ''
                this.MaNCC = ''
                this.TenNCC = ''
        }
        copy(item: TonKhoHienTai) {
                this.IdTk = item.IdTk;
                this.IdKho = item.IdKho;
                this.TenKho = item.TenKho;
                this.MaKho = item.MaKho;
                this.IdHh = item.IdHh;
                this.TenHH = item.TenHH;
                this.MaHH = item.MaHH;
                this.Solo = item.Solo;
                this.Soluong = item.Soluong;
                this.Sopo = item.Sopo;
                this.Tinhtrang = item.Tinhtrang;
                this.Ghichu = item.Ghichu;
                this.Dvt = item.Dvt;
                this.TenDVT = item.TenDVT;
                this.TenNHH = '';
                this.TenLoaiHH = '';
                this.HanSuDung = item.HanSuDung;
                this.NgaySanXuat = item.NgaySanXuat;
                this.TagInfo = [];
                if (item.TagInfo && item.TagInfo.length > 0) {
                        item.TagInfo.forEach(el => this.TagInfo.push(el))
                }
                this.PalletText = item.PalletText;
                this.MaSub = item.MaSub;
                this.SoXeSoMe = item.SoXeSoMe;
                this.NgayNhanHang = item.NgayNhanHang;
                this.GhiChuDNNK = item.GhiChuDNNK;
                this.MaNCC = item.MaNCC;
                this.TenNCC = item.TenNCC;
        }
}
export class UpdateTagInfoRequestBody extends BaseModel {
        TagInfo: string[]
        InventoriesId: number[]
        clear() { this.TagInfo = [], this.InventoriesId = [] }
        copy(_item: UpdateTagInfoRequestBody) { this.TagInfo = _item.TagInfo, this.InventoriesId = _item.InventoriesId }
}

export class UpdateNoteQARequestBody extends BaseModel {
        NoteQA: string
        InventoriesId: number[]
        clear() { this.NoteQA = "", this.InventoriesId = [] }
        copy(_item: UpdateNoteQARequestBody) { this.NoteQA = _item.NoteQA, this.InventoriesId = _item.InventoriesId }
}